import $ from 'jquery';
export const digital = () => {
	let event = "digitalData loaded";
	let env = "prod";
	let pageName0 = "www:wel:us:";
	const digitalData = { "event": "", "environment": "", "formName": "", "page": { "pageName": "", "section": "", "type": "" }, "site": { "country": "en", "language": "en-us", "platform": "web" } };
	const ecommerce = { "products": [{ "sku": "", "price": "", "category": "", "parentName": "", "parentId": "", "type": "" }] };

	let pageName1 = "homepage";
	let pageName2 = "";
	let pageName3 = "";
	let pageName4 = "";
	let pageName5 = "";
	let section = "homepage";
	let type = "homepage";
	let ecommerce_category = "";
	let ecommerce_type = "";
	let ecommerce_parentName = "";
	let ecommerce_parentName_Part = "";
	let ecommerce_parentId = "";
	let flag = 0;
	let hostName = window.location.hostname;
	let pathName = window.location.pathname;
	let skus = "";
	let price = "";
	//let partURI = new Array(5);
	let partURI = pathName.split('/');

	//Setting PageName based on 1st Part
	if (partURI[1] === "") {
	}
	else if (partURI[1] === "pin") {
		pageName1 = "pin";
		pageName2 = ":activate";
		section = "pin";
		type = "activate";
	}
	else if (partURI[1] === "cart") {
		pageName1 = "cart";
		section = "cart";
		type = "cart";
	}
	else if (partURI[1] === "blog") {
		pageName1 = partURI[1];
		section = partURI[1];
		type = partURI[1];
	}
	else if ((partURI[1]).length < 6) {
		pageName1 = partURI[1];
		section = partURI[1];
		type = "category page";
	}
	else if (partURI[1] === "investment-banking") {
		pageName1 = "ib";
		section = "ib";
		type = "category page";
	}
	else if (partURI[1] === "product-tour") {
		pageName2 = ":product-tour";
		type = "product tour";
	}
	else if (partURI[1] === "associations") {
		pageName1 = "partners";
		pageName2 = ":associations";
		section = "partners";
		type = "partners";
	}
	else if (partURI[1] === "campus-representatives") {
		pageName1 = "partners";
		pageName2 = ":campus-reps";
		section = "partners";
		type = "partners";
	}
	else if (partURI[1] === "corporates") {
		pageName1 = "partners";
		pageName2 = ":firms-corporations";
		section = "partners";
		type = "partners";
	}
	else if (partURI[1] === "about-us") {
		pageName1 = "about";
		section = "about";
		type = "about";
	}
	else if (partURI[1] === "securities") {
		pageName1 = "finra";
		section = "finra";
		type = "category page";
	}
	else if (partURI[1] === "accounting") {
		pageName1 = "accounting";
		section = "accounting";
		type = "category page";
	}
	else if (partURI[1] === "finance") {
		pageName1 = "finance";
		section = "finance";
		type = "category page";
	}
	else if (partURI[1] === "comptia-network-plus" || partURI[1] === "network") {
		pageName1 = "network";
		section = "network";
		type = "category page";
	}
	else if (partURI[1] === "comptia-security-plus" || partURI[1] === "security") {
		pageName1 = "security";
		section = "security";
		type = "category page";
	}
	else if (partURI[1] === "aws-csa") {
		pageName1 = "aws";
		section = "aws";
		type = "category page";
	}
	else if (partURI[1] === "comptia-a-plus") {
		pageName1 = "aplus";
		section = "aplus";
		type = "category page";
	}
	else if (partURI[1] === "comptia-pentest") {
		pageName1 = "pentest";
		section = "pentest";
		type = "category page";
	}
	else if (partURI[1] === "comptia-project") {
		pageName1 = "project";
		section = "project";
		type = "category page";
	}
	else if (partURI[1] === "caia-curriculum") {
		pageName1 = "caia-curriculum";
		section = "caia-curriculum";
		type = "category page";
	}
	else if (partURI[1] === "advancedplacement") {
		pageName1 = "ap";
		section = "ap";
		type = "category page";
	}
	else if (partURI[1] === "fmi") {
		pageName1 = "fmi";
		section = "fmi";
		type = "category page";
	}
	else if (partURI[1] === "blockchain") {
		pageName1 = "blockchain";
		section = "blockchain";
		type = "category page";
	}
	else if (partURI[1].indexOf("become-a-contributor") !== -1) {
		pageName1 = "contribute";
		section = "contribute";
		type = "contribute";
	}
	else if (partURI[1] === "contact-us" || partURI[1].indexOf("contact") !== -1) {
		pageName1 = "contact";
		section = "contact";
		type = "contact";
	}
	else if (partURI[1] === "mobile-app") {
		pageName1 = "mobile-app";
		section = "about";
		type = "about";
	}
	else if (partURI[1] === "partner-with-wiley") {
		pageName1 = "partners";
		pageName2 = ":partnership";
		section = "partners";
		type = "partners";
	}
	else if (partURI[1].indexOf("partner") !== -1) {
		pageName1 = "partner";
		pageName2 = ":partner";
		section = "partner";
		type = "partner";
	}
	else if (partURI[1] === "training") {
		pageName1 = "partners";
		pageName2 = ":training";
		section = "partners";
		type = "partners";
	}
	else if (partURI[1] === "universities") {
		pageName1 = "partners";
		pageName2 = ":universities";
		section = "partners";
		type = "partners";
	}
	else if (partURI[1].indexOf("coronavirus") !== -1) {
		pageName2 = ":" + partURI[1];
		section = "coronavirus";
		type = "coronavirus";
	}
	else if (partURI[1] !== null) {
		if (partURI[1].length > 0) {
			pageName2 = ":" + partURI[1];
		}
	}


	//Setting PageName based on 2nd Part
	if (partURI[2] == null || flag === 1) {
	}
	else if (partURI[2] === "resources" || partURI[2] === "support" || partURI[2] === "considering" || partURI[2].indexOf("virtual-classrooms") !== -1) {
		pageName2 = ':' + partURI[2];
		type = partURI[2];
	}
	else if (partURI[2] === "why-sybex" || partURI[2] === "why-wiley") {
		pageName2 = ":why-wiley";
		type = "why wiley";
	}
	else if (partURI[2] === "actprepguide") {
		pageName2 = ":products";
		pageName3 = ":prep-guide";
		type = "product detail";
		ecommerce_type = "Print";
	}
	else if (partURI[2] === "product-availability-schedule") {
		pageName2 = ":product-availability-schedule";
		type = "product availability schedule";
	}
	else if (partURI[2] === "mobile-app") {
		pageName2 = ":mobile-app";
		type = "mobile app";
	}
	else if (partURI[2] === "definitely-taking") {
		pageName2 = ":taking";
		type = "taking";
	}
	else if (partURI[2] === "live-courses") {
		pageName2 = ":live-courses";
		type = "live courses";
	}
	else if (partURI[2].indexOf("products") !== -1) {
		pageName2 = ":products";
		type = "product landing page";
	}
	else if (partURI[2] === "apushistory") {
		event = "productDetailView";
		pageName2 = ":products";
		pageName3 = ":aphistory";
		type = "product detail";
		ecommerce_type = "Print";
	}
	else if (partURI[2].indexOf("prepguide") !== -1) {
		pageName2 = ":products";
		pageName3 = ":prepguides";
		type = "product landing page";
	}
	else if (partURI[2] === "go-for-gold") {
		pageName2 = ":about-product";
		type = "about product";
	}
	else if (partURI[2] === "success-stories") {
		pageName2 = ":success-stories";
	}
	else if (partURI[2].indexOf(partURI[1] + "-") !== -1) {
		pageName2 = ":exam-update";
		type = "exam update";
	}
	else if (partURI[2]) {
		pageName2 = ":" + partURI[2];
		if (partURI[2].indexOf("supplements") !== -1) {
			type = "product landing page ";
		}
	}

	//Setting PageName based on 3rd Part
	if (partURI[3] === null || flag === 1) {
	}
	else if (partURI[3] === "beginners-guide") {
		pageName3 = ":beginners-guide";
		event = "productDetailView";
	}
	else if (partURI[3] === "onlineprep") {
		pageName3 = ":prep-guide-bundle";
		event = "productDetailView";
		ecommerce_type = "Print Online";
	}
	else if (partURI[3] === "live-classes") {
		pageName3 = ":live-courses";
		type = "resources";
	}
	else if (partURI[3] === "success-stories") {
		pageName3 = ":success-stories";
		if (partURI[2] === "why-wiley") {
			pageName2 = ":about";
			type = "about";
		}
	}
	else if (partURI[3] === "advancedquestions") {
		pageName2 = ":products";
		pageName3 = ":advancedquestions";
		type = "product detail";
		event = "productDetailView";
	}
	else if (partURI[3] === "advancedquestions-ebook") {
		pageName2 = ":products";
		pageName3 = ":advancedquestions-ebook";
		type = "product detail";
		event = "productDetailView";
	}
	else if (partURI[3] === "books") {
		pageName2 = ":products";
		pageName3 = ":books";
		type = "product detail";
		event = "productDetailView";
	}
	else if (partURI[3] === "ebook") {
		pageName2 = ":products";
		pageName3 = ":ebook";
		type = "product detail";
		event = "productDetailView";
	}
	else if (partURI[3] === "official") {
		pageName2 = ":products";
		pageName3 = ":official";
		type = "product detail";
		event = "productDetailView";
	}
	else if (partURI[3] === "official-ebook") {
		pageName2 = ":products";
		pageName3 = ":official-ebook";
		type = "product detail";
		event = "productDetailView";
	}
	else if (partURI[3] === "apushistory") {
		event = "productDetailView";
		pageName2 = ":products";
		pageName3 = ":aphistory";
		type = "product detail";
		ecommerce_type = "Print";
	}
	else if (partURI[3] === "quantitative") {
		pageName2 = ":products";
		pageName3 = ":quantitative";
		type = "product detail";
		event = "productDetailView";
	}
	else if (partURI[3] === "quantitative-ebook") {
		pageName2 = ":products";
		pageName3 = ":quantitative-ebook";
		type = "product detail";
		event = "productDetailView";
	}
	else if (partURI[3] === "verbal") {
		pageName2 = ":products";
		pageName3 = ":verbal";
		type = "product detail";
		event = "productDetailView";
	}
	else if (partURI[3] === "verbal-ebook") {
		pageName2 = ":products";
		pageName3 = ":verbal-ebook";
		type = "product detail";
		event = "productDetailView";
	}
	else if (partURI[3] === "level-1-lecture-videos") {
		pageName1 = "resources";
		pageName2 = ":level-1-lecture-videos";
	}
	else if (partURI[3]) {
		pageName3 = ":" + partURI[3];
		if (partURI[2].indexOf("products") !== -1 && partURI[3].indexOf("level") == -1) {
			event = "productDetailView";
			type = "product detail";
		}
	}

	//Setting PageName based on 4th Part
	if (partURI[4]) {
		pageName4 = ':' + partURI[4];
		if (partURI[2].indexOf("products") !== -1 && partURI[3].indexOf("level") !== -1) {
			event = "productDetailView";
			type = "product detail";
		}
	}
	//Setting PageName based on 5th Part
	if (partURI[5]) {
		pageName5 = ':' + partURI[5];
	}

	if (partURI[1] === "blog") {
		pageName1 = partURI[1];
		section = partURI[1];
		type = partURI[1];
		if (partURI[2]) {
			if ((partURI[2]).length < 8) {
				pageName2 = ':' + partURI[2];
				section = partURI[2];
			}
			else {
				if (global.product) {
					pageName2 = ':' + global.product;
					section = global.product;
				}
				pageName3 = ':' + partURI[2];
			}
		}
	}

	//Higher PageName should be set only when Lower Pagename having value otherwise null
	if (pageName2 === null) {
		pageName3 = null;
	}
	if (pageName3 === null) {
		pageName4 = null;
	}
	if (pageName4 === null) {
		pageName5 = null;
	}

	//Free-Trail section 
	if (partURI[1] == "free-trial" || partURI[2] == "free-trial" || partURI[3] == "free-trial" || partURI[4] == "free-trial") {
		type = "free trial";
		ecommerce_parentName = $('.try-wiley-box-heading').text();
		ecommerce_parentId = $("#selectCourse option").attr('value');
		skus = ecommerce_parentId;
		digitalData.formName = "freetrial|" + section;
	}

	if (partURI[1] == "pop-quiz" || partURI[2] == "pop-quiz" || partURI[3] == "pop-quiz" || partURI[4] == "pop-quiz") {
		digitalData.formName = "popquiz|" + section;
	}
	if (partURI[1] == "pop-quiz-thank-you" || partURI[2] == "pop-quiz-thank-you" || partURI[3] == "pop-quiz-thank-you" || partURI[4] == "pop-quiz-thank-you") {
		digitalData.formName = "TRUE";
		digitalData.formSuccessPage = digitalData.formName;
		delete digitalData.formName;
	}
	if (partURI[1] == "pop-quiz-thank-you") {
		pageName1 = "pop-quiz";
		pageName2 = ":pop-quiz-thank-you";
	}

	//eCommerce section 
	if ((pageName1 == "act" || pageName1 == "gmat" || pageName1 == "advancedplacement") && pageName3 && $('.new-price')) {
		type = "product detail";
		var av = $('.retail-icons a:contains(Wiley)').attr('href');
		if (!(av)) {
			var av = $('.retail-icons a:contains(WILEY)').attr('href');
		}
		if (av) {
			skus = av.substring(av.lastIndexOf('-') + 1, av.length);
		}
		price = $('.new-price').html();
		if (price) {
			price = price.replace('$', '');
		}
		ecommerce_parentName = $('.pdp-page-title').text();
		ecommerce_parentName_Part = ecommerce_parentName.split(':');
		if (ecommerce_type === "" || !ecommerce_type) {
			ecommerce_type = ecommerce_parentName_Part[1];
			if (ecommerce_type) {
				ecommerce_type = ecommerce_type.replace(/\+/g, ' ');
				ecommerce_type = ecommerce_type.replace(/\   /g, ' ');
				ecommerce_type = ecommerce_type.replace(/\  /g, ' ');
			}
		}
		ecommerce_parentName = ecommerce_parentName.replace(/\®|™/g, '');
		ecommerce_parentName = ecommerce_parentName.replace(/\:/g, ' ');
		ecommerce_parentName = ecommerce_parentName.replace(/\+/g, ' ');
		ecommerce_parentName = ecommerce_parentName.replace(/\    /g, ' ');
		ecommerce_parentName = ecommerce_parentName.replace(/\   /g, ' ');
		ecommerce_parentName = ecommerce_parentName.replace(/\  /g, ' ');
		ecommerce_parentId = "WEL_" + ecommerce_parentName.replace(/\ /g, '_');
		ecommerce_parentId = ecommerce_parentId.replace(/\–/g, '_');
		ecommerce_parentId = ecommerce_parentId.replace(/\___/g, '_');
		ecommerce_parentId = ecommerce_parentId.replace(/\__/g, '_');
	} else if ($(".pdp-page-title").attr("base_sku") && pageName2) {
		type = "product detail";
		ecommerce_parentName = $('.pdp-page-title').text();
		ecommerce_parentId = $(".pdp-page-title").attr("base_sku");
		skus = $(".SET").attr("value");
		if (!skus) {
			skus = $(".Print").attr("value");
		}
		if (!skus) {
			skus = $(".Level").attr("value");
		}
		if (!skus) {
			skus = ecommerce_parentId;
		}
		price = $('.new-price').html();
		if (price) {
			price = price.replace('$', '');
		}
		ecommerce_type = $("input[type='radio']:checked").attr('value');
	}

	if (ecommerce_parentId) {
		event = "productDetailView";
		ecommerce_category = pageName1;
		ecommerce.products[0].sku = skus;
		ecommerce.products[0].price = price;
		ecommerce.products[0].category = ecommerce_category;
		ecommerce.products[0].parentName = ecommerce_parentName;
		ecommerce.products[0].parentId = ecommerce_parentId;
		ecommerce.products[0].type = ecommerce_type;
		//Appending ecommerce section
		digitalData.ecommerce = ecommerce;
	}

	digitalData.event = event;
	digitalData.environment = env;
	digitalData.page.pageName = pageName0 + pageName1 + pageName2 + pageName3 + pageName4 + pageName5;
	digitalData.page.section = section;
	digitalData.page.type = type;
	window.digitalData = digitalData;

	if (hostName !== "www.efficientlearning.com") {
		digitalData.environment = "dev";
		//console.log(digitalData);
	}
}